import React from "react";

const UtilizationProgress = ({ value, color = "#1976d2", label = "Utilization" }) => {
  return (
    <div className="font-sans flex flex-col space-y-1">
      {/* Label + Percentage */}
      <div className="flex flex-row justify-between">
        <span
          className="text-[12px] text-foreground"
        >
          {label}
        </span>
        <span
          className="text-[12px] text-foreground"
        >
          {value}%
        </span>
      </div>

      {/* Progress Bar */}
      <div className="w-full h-2 rounded-full overflow-hidden bg-background">
        <div
          className="h-full rounded-full transition-all duration-300"
          style={{ width: `${value}%`, backgroundColor: color }}
        ></div>
      </div>
    </div>
  );
};

export default UtilizationProgress;
